<template lang="html">
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form @submit.prevent="submit()">

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>Telefone<span class="text-muted">(número para o bot)</span></label>
              <input-phone
                placeholder="Telefone"
                :model.sync="model.phoneMessageWhats"
              ></input-phone>
            </d-col>

          </d-form-row>

          <d-form-row>

            <!-- Send Message -->
            <d-col md="12" class="form-group">
              <label>Mensagem de envio <span class="text-muted">(corpo do whatsapp)</span></label>
              <textarea class="form-control" rows="10" v-model="model.sendMessageWhats"></textarea>
            </d-col>

          </d-form-row>

          <d-form-row>
            <d-button type="submit" class="btn-primary">Salvar</d-button>
          </d-form-row>
        </d-form>

      </d-list-group-item>
    </d-list-group>
  <!-- </d-card> -->
</template>

<script>
import { mapActions } from 'vuex';
import Editor from '_shared/Editor.vue';
import Events from '_utils/events';
import InputPhone from '_shared/InputPhone.vue';
import SettingsService from '_services/rest/modules/settings';
import { _LOAD_MODEL_MESSAGE_, MESSAGES } from './SettingsModel';

export default {
  name: 'messages-form',
  components: {
    Editor,
    InputPhone,
  },
  data() {
    return {
      model: { ...MESSAGES },
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
      'getSettings',
    ]),
    submit() {
      this.loading = true;
      SettingsService.saveOptions(this.model, 'message')
        .then(() => {
          this.getSettings();
          this.activeAlert({ message: 'Mensagens salvas com sucesso', theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_MESSAGE_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
.text-muted { font-size: 12px;}
</style>
